module.exports = __webpack_public_path__ + "media/src/components/SubscriptionPlans/img/visa-06ecebe681659c89a81250e77feea460.png";